import styled from "styled-components";
import { FlexContainer } from "../../BaseComponents/Flex";
import { StyledBackgroundImage } from "../../framework/lazy/StyledBgImage";

export const ImageContainer = styled.div`
	margin-bottom: 30px;
`;
export const StandardImageWrapper = styled(FlexContainer).attrs(({}) => ({}))`
	min-height: ${({ minHeight }) => (minHeight ? minHeight : "")};
	flex-direction: column;
	${StyledBackgroundImage} {
		border-top-left-radius: ${({ theme }) => theme.border.radius};
		border-top-right-radius: ${({ theme }) => theme.border.radius};
	}
`;
